export class SIQButtonTheme {
  selectedColor = "null";
  normalColor = "null";
}
//# sourceMappingURL=SIQButtonTheme.js.map